import 'core-js/stable';
import 'alpinejs';
import '@/bugsnag';
import '@/broadcasting';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import PortalVue from 'portal-vue';
import '@/fontawesome';
import Element from '@/element';
import '../sass/element.scss';
import i18n from '@/i18n';
import crud from '@/mixins/crud';
import globalMixins from '@/mixins/global';
import activeLink from '@/directives/activeLink';

// window.addEventListener('load', images);

for (const element of document.querySelectorAll('.alert.success')) {
    setTimeout(() => {
        element.remove();
    }, 2000);
}

document.body.addEventListener('click', (event) => {
    if (event.target && event.target.matches('.alert [role="button"]')) {
        event.target.closest('.alert').remove();
    }
});

Vue.use(PortalVue);
Vue.use(VueScrollTo);

Vue.directive('active-link', {
    inserted: activeLink,
});

Vue.mixin(globalMixins);
Vue.mixin(crud);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.productionTip = false;

Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value),
});

const root = document.querySelector('#app');
let app;
if (root) {
    if (app) {
        app.$destroy(true);
    }

    app = new Vue({
        i18n,
        el: '#app',
        data: {
            nav: {
                left: false,
                right: false,
            },
        },
        created() {
            window.addEventListener('scroll', this.scrollHandler);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scrollHandler);
        },
        methods: {
            scrollHandler() {
                const { logo } = this.$refs;

                if (logo) {
                    if (window.pageYOffset > 50) {
                        logo.classList.remove('xl:w-64');
                    } else {
                        logo.classList.add('xl:w-64');
                    }
                }
            },
            toggleNav(side) {
                this.nav[side] = !this.nav[side];
            },
            handleSuccess(response, msg) {
                if (response.data.status === 'success' && msg) {
                    this.$notify.success({
                        title: this.$t('Success'),
                        message: msg,
                        duration: 2000,
                    });
                } else if (response.data.status === 'failure') {
                    if (response.data.message) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: this.$t(response.data.message),
                            duration: 4000,
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: this.$t('Something went wrong. Please contact your local studio.'),
                            duration: 0,
                        });
                    }
                }
            },
            handleError(error) {
                this.loadErrors(error);
                if (error.response) {
                    if (error.response.data.message) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: this.$t(error.response.data.message),
                            duration: 4000,
                        });
                    } else if (!['failure'].includes(error.response.data.status)) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: this.$t('Something went wrong. Please contact your local studio.'),
                            duration: 0,
                        });
                    }
                } else if (error.request) {
                    this.$notify.error({
                        title: this.$t('Error'),
                        message: this.$t('Unable to connect to the internet. Please check your connection then refresh this page.'),
                        duration: 0,
                    });
                } else {
                    this.$notify.error({
                        title: this.$t('Error'),
                        message: this.$t(`Something went wrong: ${error.message}`),
                        duration: 0,
                    });
                }
            },
        },
    }).$mount(root);
}
